module.exports = __webpack_public_path__ + "static/media/MD_MASARY_ByAramBohosian.d365d314.jpg";